import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
	NotificationService,
	NotificationType,
	SymbolService,
	UserDeviceService
} from '../../../modules/shared/services';
import { OmsAction } from '../actions/oms.action';
import { timer } from 'rxjs';
import { DeviceTypeEnum } from '../../../modules/account-activity';
import { EasyState, From, IBaseOrderEntity } from '../../../modules/order';
import { OrderStore } from '../stores/order.store';
import { DraftAction } from '../actions/draft.action';
import { OfflineAction } from '../actions/offline.action';
import { LightModes } from '@easy-lib/constants';
import { AlgoAction } from '../actions/algo.action';

@Injectable({
	providedIn: 'root'
})
export class OrderFacade {
	protected store = inject(Store);
	protected orderStore = inject(OrderStore);
	protected symbolService = inject(SymbolService);
	protected userDeviceService = inject(UserDeviceService);
	protected notificationService = inject(NotificationService);
	public get orderFromType() {
		return this.userDeviceService.deviceType === DeviceTypeEnum.Desktop ? From.OrbisDesktop : From.OrbisMobile;
	}
	load(params?: { checkOrderPlace?: boolean }) {
		this.store.dispatch(OmsAction.load(params ?? {}));
		this.store.dispatch(AlgoAction.load());
	}
	resetOrderState(id: string) {
		//TODO:
		this.store.dispatch(OmsAction.update({ id, changes: { easyState: EasyState.Done } }));
		this.store.dispatch(DraftAction.update({ id, changes: { easyState: EasyState.Done } }));
		this.store.dispatch(OfflineAction.update({ id, changes: { easyState: EasyState.Done } }));
	}

	getFilterLightClass(isLightOn: boolean): string[] {
		let lightMode = LightModes.Filled;
		if (!isLightOn) lightMode = LightModes.Empty;
		return [lightMode];
	}
	notifyInfo(message: string, delay = 0) {
		const obs$ = timer(delay).subscribe(() => {
			this.notificationService.alert(message, NotificationType.secondary);
		});
		function cancel() {
			obs$.unsubscribe();
		}
		return { cancel };
	}
	notifyError(message: string) {
		this.notificationService.alert(message, NotificationType.danger);
	}
	notifySuccess(message: string) {
		this.notificationService.alert(message, NotificationType.success);
	}
	notifyWarning(message: string) {
		this.notificationService.alert(message, NotificationType.warning);
	}
	updateSymbolName(orders: IBaseOrderEntity[]) {
		return orders.map(order => ({
			...order,
			symbolName: this.symbolService?.symbolByIsin?.[order.symbolIsin]?.symbolName
		}));
	}
}
